import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Account, TPTariffsMap } from '@personal-area/global/accounts/models';
import { Role } from '@personal-area/global/users/models';

@Pipe({
  name: 'accountName',
  pure: false,
  standalone: true,
})
export class AccountNamePipe implements PipeTransform {

  constructor(private _translateService: TranslateService) {
  }

  transform(account: Account, includeServer = false, useCustomName = true): string {
    if (account.name && useCustomName) {
      return account.name;
    }
    if (account.type === Role.TradingPlatform) {
      return (includeServer ? this._translateService.instant('open-account.label.tp') : '')
        + ` ${this._translateService.instant(`register-account.label.${TPTariffsMap.get(account.tariff)}`)}`
        + ` ${account.id}`
    }
    return this._translateService.instant(('register-account.label.' + account.tariff))
      + (includeServer ? ` ${account.extras?.server.type.toUpperCase()}` : '')
      + ` ${account.login}`;
  }

}
